// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralFillActive, neutralFillStealthHover, neutralForegroundRest, neutralLayerCard, neutralOutlineActive } from "@microsoft/fast-components-styles-msft";

import { enums } from "../../../../utils/enums";

export const ReportMenuSuperAppStyles = (config: DesignSystem) => ({
    reportMenuSuperAppContainer: {
        "max-height": "75vh",
        "max-width": "100vw",
        width: "500px",
        height: "100%",
        "font-size": "16px",
        background: neutralFillActive,
        "border-radius": "12px 12px 0 0",
        margin: "0",
        "padding-top": "0 !important",
        "padding-bottom": "70px !important",
        "min-height": "450px",

        "& .cwt-menu-header": {
            padding: "20px 27px",
            "border-bottom": "1px solid",
            "border-color": neutralOutlineActive,
            background: neutralLayerCard,
            "margin-bottom": "24px",
            position: "sticky",
            top: "0",
            "font-weight": "bold",

            "& .cwt-icon-label": {
                "font-size": "22px",
                color: neutralForegroundRest,
                padding: "0"
            }
        },

        "& li": {
            cursor: "pointer",
            padding: "14px 24px !important",
            background: neutralLayerCard,
            "font-size": "16px",
            "line-height": "20px",

            "&:hover": {
                background: neutralFillStealthHover
            }
        }
    }
});